export const SET_USERS = (state, payload) => {
  state.users = payload;
}

export const SET_USER = (state, payload) => {
  state.user = payload;
}

export const SET_COLLECTIONS = (state, payload) => {
  state.collections = payload
}

export const SET_TEMPLATES = (state, payload) => {
  state.templates = payload
}